module.exports = __webpack_public_path__ + "static/media/customer-service.6e0d7c1b.svg";